// authActions.js
import { markCurrentSessionEnded, resetSessionEndMarker } from "../../utils/sessionLifecycle";

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';

export const loginRequest = ({ username, password, rememberMe = false }) => ({
    type: LOGIN_REQUEST,
    payload: { username, password, rememberMe }
});


export const loginSuccess = (userData) => ({
    type: LOGIN_SUCCESS,
    payload: userData
});

export const loginFail = (error) => ({
    type: LOGIN_FAIL,
    error
});

export const logout = () => {
    markCurrentSessionEnded({ preferBeacon: false });
    return {
        type: LOGOUT
    };
};

export const prepareNewSession = () => {
    resetSessionEndMarker();
};

export const setAuthenticatedUser = (user) => ({
    type: SET_AUTHENTICATED_USER,
    payload: user
});
